<template>
  <tr v-if="!esEditable">
    <td class="text-center">
      <button class="btn btn-xs btn-icon btn-light-warning ml-1" @click="onEdit">
        <i class="fa fa-pen"></i>
      </button>
      <button
        class="btn btn-xs btn-icon btn-light-danger ml-1"
        @click="onDelete"
        :disabled="loading.save"
      >
        <i class="fa fa-trash-alt"></i>
      </button>
    </td>
    <td class="text-center text-nowrap">{{ row.codigo }}</td>
    <td>{{ row.agencia }}</td>
    <template v-if="isServicioValleSagrado">
      <td>{{ row.codigoAgencia }}</td>
      <td>
        <strong>{{ row.nombre }}</strong>
      </td>
      <td class="text-center">{{ row.tipo }}</td>
      <td class="text-center">{{ row.nroAdultos }}</td>
      <td class="text-center">{{ row.nroNinos }}</td>
      <td class="text-center">{{ row.idioma }}</td>
      <td>{{ row.hotel }}</td>
      <td class="text-center">
        {{ row.horaRecojo ? $dayjs(horaRecojo, 'HH:mm:ss').format('HH:mm') : '' }}
      </td>
      <td class="text-center">{{ row.ingresosBTG }}</td>
      <td>{{ row.asistente || '' }}</td>
      <td>{{ row.recomendacionesGuia }}</td>
      <td>{{ row.observacion }}</td>
      <td>{{ row.estado }}</td>
      <td>{{ row.enlaceTren ? $dayjs(row.enlaceTren, 'HH:mm:ss').format('HH:mm') : '' }}</td>
      <td>{{ row.restaurante || '' }}</td>
      <td>{{ row.lunch || '' }}</td>
      <td>{{ row.recojoPisac ? 'Sí' : '' }}</td>
    </template>
    <template v-else-if="isServicioMarasMoray">
      <td>{{ row.codigoAgencia }}</td>
      <td>
        <strong>{{ row.nombre }}</strong>
      </td>
      <td class="text-center">{{ row.tipo }}</td>
      <td class="text-center">{{ row.nroAdultos }}</td>
      <td class="text-center">{{ row.nroNinos }}</td>
      <td class="text-center">{{ row.idioma }}</td>
      <td>{{ row.hotel }}</td>
      <td class="text-center">
        {{ row.horaRecojo ? $dayjs(horaRecojo, 'HH:mm:ss').format('HH:mm') : '' }}
      </td>
      <td class="text-center">{{ row.ingresosBTG }}</td>
      <td>{{ row.asistente || '' }}</td>
      <td>{{ row.recomendacionesGuia }}</td>
      <td>{{ row.observacion }}</td>
      <td>{{ row.estado }}</td>
    </template>
    <template v-else-if="isServicioIntiRaymi">
      <td>
        <strong>{{ row.nombre }}</strong>
      </td>
      <td class="text-center">{{ row.tipo }}</td>
      <td class="text-center">{{ row.nroAdultos }}</td>
      <td class="text-center">{{ row.nroNinos }}</td>
      <td class="text-center">{{ row.idioma }}</td>
      <td>{{ row.hotel }}</td>
      <td>{{ row.sacsayhuaman }}</td>
      <td>{{ row.qoricancha }}</td>
      <td>{{ row.lunch || '' }}</td>
      <td>{{ row.restaurante || '' }}</td>
      <td>{{ row.observacion }}</td>
      <td>{{ row.estado }}</td>
    </template>
    <template v-else>
      <td>{{ row.codigoAgencia }}</td>
      <td>
        <strong>{{ row.nombre }}</strong>
      </td>
      <td class="text-center">{{ row.tipo }}</td>
      <td class="text-center">{{ row.nroAdultos }}</td>
      <td class="text-center">{{ row.nroNinos }}</td>
      <td class="text-center">{{ row.idioma }}</td>
      <td>{{ row.hotel }}</td>
      <td class="text-center">
        {{ row.horaRecojo ? $dayjs(horaRecojo, 'HH:mm:ss').format('HH:mm') : '' }}
      </td>
      <td class="text-center">{{ row.ingresosBTG }}</td>
      <td class="text-center">{{ row.ingresosCatedral }}</td>
      <td class="text-center">{{ row.ingresosQoricancha }}</td>

      <td>{{ row.asistente || '' }}</td>
      <td>{{ row.recomendacionesGuia }}</td>
      <td>{{ row.observacion }}</td>
      <td>{{ row.estado }}</td>
    </template>
  </tr>
  <ValidationObserver v-else tag="tr" ref="form" :vid="String(row.idBibliaRegistro)">
    <td class="text-center">
      <button
        class="btn btn-xs btn-icon btn-light-primary"
        @click="onSave"
        :disabled="loading.save"
      >
        <i class="fa fa-check"></i>
      </button>
      <button
        class="btn btn-xs btn-icon btn-secondary ml-1"
        @click="onRemove"
        :disabled="loading.save"
      >
        <i class="fa fa-times"></i>
      </button>
    </td>
    <td></td>
    <td>
      <InputSelect
        v-model="row.tempAgencia"
        :errorMode="'tooltip'"
        :vid="`agencia_${row.idBibliaRegistro}`"
        name="Agencia"
        rules="required"
        :options="agencias"
        label="nombre"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <template v-if="isServicioValleSagrado">
      <td>
        <InputText
          v-model="row.tempFile"
          :errorMode="'tooltip'"
          :vid="`file_${row.idBibliaRegistro}`"
          name="File"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempNombre"
          :errorMode="'tooltip'"
          :vid="`nombre_${row.idBibliaRegistro}`"
          name="Nombre"
          rules="required"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempTipo"
          :errorMode="'tooltip'"
          :vid="`tipo_${row.idBibliaRegistro}`"
          name="Tipo"
          rules="required"
          :options="servicio_tipos"
          label="sigla"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempPAX"
          :errorMode="'tooltip'"
          :vid="`pax_${row.idBibliaRegistro}`"
          name="PAX"
          rules="required|number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempCHD"
          :errorMode="'tooltip'"
          :vid="`chd_${row.idBibliaRegistro}`"
          name="CHD"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempIdioma"
          :errorMode="'tooltip'"
          :vid="`idioma_${row.idBibliaRegistro}`"
          name="Idioma"
          rules="required"
          :options="idiomas"
          label="abreviatura"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempHotel"
          :errorMode="'tooltip'"
          :vid="`hotel_${row.idBibliaRegistro}`"
          name="Hotel"
          :options="hoteles"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempHoraRecojo"
          :errorMode="'tooltip'"
          :vid="`horaRecojo_${row.idBibliaRegistro}`"
          name="Hora Recojo"
          rules="time"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempIngresoBTG"
          :errorMode="'tooltip'"
          :vid="`ingresoBTG_${row.idBibliaRegistro}`"
          name="BTG"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputSelect
          v-model="row.tempAsistente"
          :errorMode="'tooltip'"
          :vid="`asistente_${row.idBibliaRegistro}`"
          name="Asistente"
          :options="asistentes"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputText
          v-model="row.tempRecomendaciones"
          :errorMode="'tooltip'"
          :vid="`recomendaciones_${row.idBibliaRegistro}`"
          name="Recomendaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempObservaciones"
          :errorMode="'tooltip'"
          :vid="`observaciones_${row.idBibliaRegistro}`"
          name="Observaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputSelect
          v-model="row.tempEstado"
          :options="estados"
          :errorMode="'tooltip'"
          :vid="`estado_${row.idBibliaRegistro}`"
          name="Estado"
          label="label"
          rules="required"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputText
          v-model="row.tempEnlaceTren"
          :errorMode="'tooltip'"
          :vid="`enlaceTren_${row.idBibliaRegistro}`"
          name="Enlace Tren"
          rules="time"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempRestaurante"
          :options="restaurantes"
          :errorMode="'tooltip'"
          :vid="`restaurante_${row.idBibliaRegistro}`"
          name="Restaurante"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempLunch"
          :options="lunchs"
          :errorMode="'tooltip'"
          :vid="`lunch_${row.idBibliaRegistro}`"
          name="Lunch"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputCheckbox v-model="row.tempRecojoPisac"></InputCheckbox>
      </td>
    </template>
    <template v-else-if="isServicioMarasMoray">
      <td>
        <InputText
          v-model="row.tempFile"
          :errorMode="'tooltip'"
          :vid="`file_${row.idBibliaRegistro}`"
          name="File"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempNombre"
          :errorMode="'tooltip'"
          :vid="`nombre_${row.idBibliaRegistro}`"
          name="Nombre"
          rules="required"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempTipo"
          :errorMode="'tooltip'"
          :vid="`tipo_${row.idBibliaRegistro}`"
          name="Tipo"
          rules="required"
          :options="servicio_tipos"
          label="sigla"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempPAX"
          :errorMode="'tooltip'"
          :vid="`pax_${row.idBibliaRegistro}`"
          name="PAX"
          rules="required|number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempCHD"
          :errorMode="'tooltip'"
          :vid="`chd_${row.idBibliaRegistro}`"
          name="CHD"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempIdioma"
          :errorMode="'tooltip'"
          :vid="`idioma_${row.idBibliaRegistro}`"
          name="Idioma"
          rules="required"
          :options="idiomas"
          label="abreviatura"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempHotel"
          :errorMode="'tooltip'"
          :vid="`hotel_${row.idBibliaRegistro}`"
          name="Hotel"
          :options="hoteles"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempHoraRecojo"
          :errorMode="'tooltip'"
          :vid="`horaRecojo_${row.idBibliaRegistro}`"
          name="Hora Recojo"
          rules="time"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempIngresoBTG"
          :errorMode="'tooltip'"
          :vid="`ingresoBTG_${row.idBibliaRegistro}`"
          name="BTG"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputSelect
          v-model="row.tempAsistente"
          :errorMode="'tooltip'"
          :vid="`asistente_${row.idBibliaRegistro}`"
          name="Asistente"
          :options="asistentes"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputText
          v-model="row.tempRecomendaciones"
          :errorMode="'tooltip'"
          :vid="`recomendaciones_${row.idBibliaRegistro}`"
          name="Recomendaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempObservaciones"
          :errorMode="'tooltip'"
          :vid="`observaciones_${row.idBibliaRegistro}`"
          name="Observaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputSelect
          v-model="row.tempEstado"
          :options="estados"
          :errorMode="'tooltip'"
          :vid="`estado_${row.idBibliaRegistro}`"
          name="Estado"
          label="label"
          rules="required"
          input-class="form-control-table"
        ></InputSelect>
      </td>
    </template>
    <template v-else-if="isServicioIntiRaymi">
      <td>
        <InputText
          v-model="row.tempNombre"
          :errorMode="'tooltip'"
          :vid="`nombre_${row.idBibliaRegistro}`"
          name="Nombre"
          rules="required"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempTipo"
          :errorMode="'tooltip'"
          :vid="`tipo_${row.idBibliaRegistro}`"
          name="Tipo"
          rules="required"
          :options="servicio_tipos"
          label="sigla"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempPAX"
          :errorMode="'tooltip'"
          :vid="`pax_${row.idBibliaRegistro}`"
          name="PAX"
          rules="required|number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempCHD"
          :errorMode="'tooltip'"
          :vid="`chd_${row.idBibliaRegistro}`"
          name="CHD"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempIdioma"
          :errorMode="'tooltip'"
          :vid="`idioma_${row.idBibliaRegistro}`"
          name="Idioma"
          rules="required"
          :options="idiomas"
          label="abreviatura"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempHotel"
          :errorMode="'tooltip'"
          :vid="`hotel_${row.idBibliaRegistro}`"
          name="Hotel"
          :options="hoteles"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempSacsayhuaman"
          :options="sacsayhuamanColors"
          :errorMode="'tooltip'"
          :vid="`sacsayhuaman_${row.idBibliaRegistro}`"
          name="Sacsayhuaman"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempQoricancha"
          :options="qoricanchaOptions"
          :errorMode="'tooltip'"
          :vid="`qoricancha_${row.idBibliaRegistro}`"
          name="Qoricancha"
          label="label"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputSelect
          v-model="row.tempLunch"
          :options="lunchs"
          :errorMode="'tooltip'"
          :vid="`lunch_${row.idBibliaRegistro}`"
          name="Lunch"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputSelect
          v-model="row.tempRestaurante"
          :options="restaurantes"
          :errorMode="'tooltip'"
          :vid="`restaurante_${row.idBibliaRegistro}`"
          name="Restaurante"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputText
          v-model="row.tempObservaciones"
          :errorMode="'tooltip'"
          :vid="`observaciones_${row.idBibliaRegistro}`"
          name="Observaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputSelect
          v-model="row.tempEstado"
          :options="estados"
          :errorMode="'tooltip'"
          :vid="`estado_${row.idBibliaRegistro}`"
          name="Estado"
          label="label"
          rules="required"
          input-class="form-control-table"
        ></InputSelect>
      </td>
    </template>
    <template v-else>
      <td>
        <InputText
          v-model="row.tempFile"
          :errorMode="'tooltip'"
          :vid="`file_${row.idBibliaRegistro}`"
          name="File"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempNombre"
          :errorMode="'tooltip'"
          :vid="`nombre_${row.idBibliaRegistro}`"
          name="Nombre"
          rules="required"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempTipo"
          :errorMode="'tooltip'"
          :vid="`tipo_${row.idBibliaRegistro}`"
          name="Tipo"
          rules="required"
          :options="servicio_tipos"
          label="sigla"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempPAX"
          :errorMode="'tooltip'"
          :vid="`pax_${row.idBibliaRegistro}`"
          name="PAX"
          rules="required|number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempCHD"
          :errorMode="'tooltip'"
          :vid="`chd_${row.idBibliaRegistro}`"
          name="CHD"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempIdioma"
          :errorMode="'tooltip'"
          :vid="`idioma_${row.idBibliaRegistro}`"
          name="Idioma"
          rules="required"
          :options="idiomas"
          label="abreviatura"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputSelect
          v-model="row.tempHotel"
          :errorMode="'tooltip'"
          :vid="`hotel_${row.idBibliaRegistro}`"
          name="Hotel"
          :options="hoteles"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>
      <td>
        <InputText
          v-model="row.tempHoraRecojo"
          :errorMode="'tooltip'"
          :vid="`horaRecojo_${row.idBibliaRegistro}`"
          name="Hora Recojo"
          rules="time"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempIngresoBTG"
          :errorMode="'tooltip'"
          :vid="`ingresoBTG_${row.idBibliaRegistro}`"
          name="BTG"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputText
          v-model="row.tempIngresoCAT"
          :errorMode="'tooltip'"
          :vid="`ingresoBTG_${row.idBibliaRegistro}`"
          name="CAT"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempIngresoQOR"
          :errorMode="'tooltip'"
          :vid="`ingresoBTG_${row.idBibliaRegistro}`"
          name="QOR"
          rules="number"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>

      <td>
        <InputSelect
          v-model="row.tempAsistente"
          :errorMode="'tooltip'"
          :vid="`asistente_${row.idBibliaRegistro}`"
          name="Asistente"
          :options="asistentes"
          label="nombre"
          input-class="form-control-table"
        ></InputSelect>
      </td>

      <td>
        <InputText
          v-model="row.tempRecomendaciones"
          :errorMode="'tooltip'"
          :vid="`recomendaciones_${row.idBibliaRegistro}`"
          name="Recomendaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputText
          v-model="row.tempObservaciones"
          :errorMode="'tooltip'"
          :vid="`observaciones_${row.idBibliaRegistro}`"
          name="Observaciones"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </td>
      <td>
        <InputSelect
          v-model="row.tempEstado"
          :options="estados"
          :errorMode="'tooltip'"
          :vid="`estado_${row.idBibliaRegistro}`"
          name="Estado"
          label="label"
          rules="required"
          input-class="form-control-table"
        ></InputSelect>
      </td>
    </template>
  </ValidationObserver>
</template>

<script>
import InputCheckbox from '../../shared/components/InputCheckbox.vue';
import InputTextArea from '../../shared/components/InputTextArea.vue';
import InputSelect from '../../shared/components/InputSelect.vue';
import InputText from '../../shared/components/InputText.vue';
import { mapState } from 'vuex';
import {
  SERVICIO_VALLE_SAGRADO_ID,
  SERVICIO_MARAS_MORAY_ID,
  SERVICIO_INTI_RAYMI_ID,
} from '../../shared/utils/constants';

export default {
  components: { InputText, InputSelect, InputTextArea, InputCheckbox },
  props: {
    row: Object,
  },
  data() {
    return {
      loading: {
        save: false,
      },
    };
  },
  computed: {
    esEditable() {
      return this.row.isNew || this.row.isEdit;
    },
    tiposPorServicio() {
      const vm = this;
      if (!vm.row.tempServicio) return [];
      return vm.serviciosTipos.filter((row) => row.idServicio == vm.row.tempServicio.idServicio);
    },
    isServicioValleSagrado() {
      return this.biblia.idServicio == SERVICIO_VALLE_SAGRADO_ID;
    },
    isServicioMarasMoray() {
      return this.biblia.idServicio == SERVICIO_MARAS_MORAY_ID;
    },
    isServicioIntiRaymi() {
      return this.biblia.idServicio == SERVICIO_INTI_RAYMI_ID;
    },
    ...mapState('biblia_registros', [
      'biblia',
      'agencias',
      'sacsayhuamanColors',
      'qoricanchaOptions',
      'servicio_tipos',
      'idiomas',
      'hoteles',
      'asistentes',
      'restaurantes',
      'lunchs',
      'estados',
    ]),
  },
  methods: {
    async onSave() {
      const vm = this;
      const validated = await this.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          icon: 'warning',
          title: 'Por favor revise o corrija los campos marcados en rojo',
        });
        return;
      }

      vm.loading.save = true;

      const fd = {
        idServicioTipo: vm.row.tempTipo?.idServicioTipo,
        idIdioma: vm.row.tempIdioma?.idIdioma,
        idAgencia: vm.row.tempAgencia?.idAgencia,
        idEstado: vm.row.tempEstado?.id,
        nombre: vm.row.tempNombre,
        nroAdultos: vm.row.tempPAX,

        nroNinos: vm.row.tempCHD,
        idHotel: vm.row.tempHotel?.idHotel,
        sacsayhuaman: vm.row.tempSacsayhuaman?.idSacsayhuaman,
        qoricancha: vm.row.tempQoricancha?.id,
        horaRecojo: vm.row.tempHoraRecojo,
        ingresosBTG: vm.row.tempIngresoBTG,
        ingresosCatedral: vm.row.tempIngresoCAT,
        ingresosQoricancha: vm.row.tempIngresoQOR,
        file: vm.row.tempFile,
        idRestaurante: vm.row.tempRestaurante?.idRestaurante,
        idLunch: vm.row.tempLunch,
        enlaceTren: vm.row.tempEnlaceTren,
        recojoPisac: vm.row.tempRecojoPisac ? 1 : 0,
        idAsistente: vm.row.tempAsistente?.idPersona,
        recomendaciones: vm.row.tempRecomendaciones,
        observaciones: vm.row.tempObservaciones,
      };

      const endpoint = vm.row.isEdit
        ? vm.axios.put(`/biblias/${vm.biblia.idBiblia}/registros/${vm.row.idBibliaRegistro}`, fd)
        : vm.axios.post(`/biblias/${vm.biblia.idBiblia}/registros`, fd);

      endpoint
        .then((response) => {
          vm.$toast.fire('', response.data.message, 'success');

          vm.$store.dispatch('biblia_registros/saveItem', {
            id: vm.row.idBibliaRegistro,
            newId: response.data.content.id,
          });
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onEdit() {
      this.$store.dispatch('biblia_registros/editItem', this.row.idBibliaRegistro);
    },
    onCancel() {
      this.row.isEdit = false;
    },
    onRemove() {
      if (this.row.isEdit) return this.onCancel();

      this.$store.dispatch('biblia_registros/removeItem', this.row.idBibliaRegistro);
    },
    async onDelete() {
      const vm = this;
      const result = await vm.$confirm.fire('', '¿Estás seguro de eliminar este registro?');
      if (!result.value) return;

      vm.loading.save = true;

      vm.axios
        .delete(`/biblias/${vm.biblia.idBiblia}/registros/${vm.row.idBibliaRegistro}`)
        .then((response) => {
          vm.$toast.fire('', response.data.message, 'success');
          this.$store.dispatch('biblia_registros/removeItem', vm.row.idBibliaRegistro);
        })
        .catch((err) => {
          vm.loading.save = false;
        });
    },
  },
};
</script>

<style></style>
